// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"39":"46a50fb4","648":"b541d835"}[chunkId] + ".chunk.css";
};